module.exports = __webpack_public_path__ + "static/img/LACQUERED-PVC-ASTON.437cd9f.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/LACQUERED-PVC-ASTON.png
// module id = ora6
// module chunks = 0